import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { formatAsTodayYesterdayTomorrow } from 'util/formatAgo';
import { formatDateFromStr } from 'util/formatDate';

export const NameDay = (
  { date }: { date: string },
) => {
  const { t } = useOTSTranslation('common');

  const getNameDay = (d: string) => {
    const isTodayOrTomorrow: string | undefined = formatAsTodayYesterdayTomorrow(d, t);
    return isTodayOrTomorrow || formatDateFromStr(d, 'cccc');
  };

  return (
    <>{getNameDay(date)}</>
  );
};
